import React, { Fragment } from "react";

export const PercentageFormat = ({ children }) =>
  children !== null ? <Fragment>{children}%</Fragment> : null;
